import { Form, Link } from "@remix-run/react";
import { Button } from "./ui/button";
import {
    Links,
    Meta,
    MetaFunction,
    Outlet,
    Scripts,
    ScrollRestoration,
    useLoaderData,
    useLocation,
  } from "@remix-run/react";
import { LinksFunction } from "@remix-run/server-runtime";
import stylesheet from "~/globals.css?url";


export const links: LinksFunction = () => [
    { rel: "stylesheet", href: stylesheet },
  ];

//Layout component for root
export function Layout({children}: {children: React.ReactNode}){
    return (
        <html lang="en" className="dark">
            <head>
                <title>Morby</title>
                <meta charSet="utf-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <Meta />
                <Links />
            </head>
            <body>
                <div className="mb-[1vh] relative w-full">
        
                    {/* Header Section */}
                    <div className="flex justify-between max-w-[1440px] mx-auto px-[5vw] py-5 items-center">

                        <div className="flex gap-4 items-center text-[#CECFD2] text-sm">
                            <Link to="/"> <img src="/morby_logo.svg" alt="Morby Logo" /> </Link>
                            {/* <Link to="/will" className=" font-medium hidden md:block hover:text-[#f2f3f6]"> My Will </Link>
                            <Link to="/settings" className={`font-medium hidden md:block hover:text-[#f2f3f6]`}> Settings </Link>
                            <Form method="post" action="/signout" className="p-0 m-0">
                                <Button type="submit" variant={null} className="font-medium p-0 gap-2 m-0 h-5 hidden md:block hover:text-[#f2f3f6]">
                                Logout
                                </Button>
                            </Form> */}
                        </div>

                    </div>

                    {/* Header border */}
                    <div className="border-b border-[#666666]/40 w-full mb-[50px]"></div>
                    

                    {/* Page content */}
                    <div className="max-w-[1440px] mx-auto px-[5vw]">
                        {children}
                    </div>
                </div>
            </body>
        </html>

        
      );
}